// extracted by mini-css-extract-plugin
export default {"about":"common_about__5gTSc","Icons":"common_Icons__OIvMx"};